"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Stagger", {
    enumerable: true,
    get: function() {
        return _Stagger.Stagger;
    }
});
const _Stagger = require("./Stagger");
